import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { RoleDetailPage } from '@/features/security/role-detail-page';
import { isRoleTab, type RoleTab } from '@/features/security/role-tabs';
import { ConsoleShell } from '@/features/shell/console-shell';

/** L'onglet actif vit dans l'URL (`?tab=holders`) : la capture de l'acte 7b pointe sur les titulaires. */
export const Route = createFileRoute('/$tenant/roles/$roleId')({
  validateSearch: (search: Record<string, unknown>): { tab: RoleTab } => ({
    tab: isRoleTab(search['tab']) ? search['tab'] : 'summary',
  }),
  component: RoleDetailRoute,
});

function RoleDetailRoute() {
  const { tenant, roleId } = Route.useParams();
  const { tab } = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  const { t } = useTranslation();

  return (
    <ConsoleShell
      tenantId={tenant}
      activeItem="roles"
      crumbs={[{ label: t('security.roles.title') }, { label: roleId, mono: true }]}
    >
      <RoleDetailPage
        tenantId={tenant}
        roleId={roleId}
        tab={tab}
        onTabChange={(next) => void navigate({ search: { tab: next }, replace: true })}
      />
    </ConsoleShell>
  );
}
